import isEmail from 'validator/lib/isEmail';

export default class CyberdyneValidator {
  public isPhone(str: string) {
    return /^[\+]?[(]?[0-9]{2,3}[)]?[-\s\.]?[0-9]{3,5}[-\s\.]?[0-9]{4,6}$/im.test(str);
  }

  public isEmptyValue(value: any) {
    return value === '' || value === null;
  }

  public isEmptyString(str: string) {
    return !(str && str.trim().length > 0);
  }

  public isStringGreaterThanLength(str: string, length: number) {
    return str && str.toString().trim().length > length;
  }

  public isStringLengthLimited(str: string, minLength: number, maxLength: number) {
    return str && str.length >= minLength && str.length <= maxLength;
  }

  public isEmail(str: string) {
    return str && isEmail(str);
  }
  public isStringLessThanLength(str: string, length: number) {
    return str && str.length < length;
  }

  public isZipCode(str: string) {
    return /^.{1,15}$/.test(str);
  }

  public isAlphaWithSpaces(str: string) {
    return /^[a-zA-Z ]*$/.test(str);
  }

  public isAlpha(str: string) {
    return /^[a-zA-Z]*$/.test(str);
  }

  public isAlphaNumericWithSpaces(str: string) {
    return /^[a-zA-Z0-9 ]*$/.test(str);
  }

  public isValidUsername(str: string) {
    return /^[a-zA-Z0-9_.@-]{6,40}$/.test(str);
  }

  public isValidPassword(str: string) {
    // tslint:disable-next-line: max-line-length
    return /(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+=])[A-Za-z\d@$!%*?&#^()_+=]/.test(str);
  }

  public isValidLatitude(latitude: number) {
    return latitude >= -90 && latitude <= 90;
  }

  public isValidLongitude(longitude: number) {
    return longitude >= -180 && longitude <= 180;
  }

  public isValidMapZoomLevel(mapZoomLevel: number) {
    return mapZoomLevel >= 1 && mapZoomLevel <= 25;
  }

  public isNonDecimalNumber(value: number) {
    return /^[0-9]+$/.test(value.toString());
  }

  public isValidNumberingPrefix(numberingPrefix: string) {
    return /^[a-zA-Z0-9 _-]{0,8}$/.test(numberingPrefix);
  }

  public isNumberInRange(num: number, lowerLimit: number, upperLimit: number) {
    return num >= lowerLimit && num <= upperLimit;
  }

  public isDeleteAllCaps(deleteWarningText: string) {
    return deleteWarningText === 'DELETE';
  }

  public isValidCaseNumber(str: string) {
    return /^[a-zA-Z0-9-]*$/.test(str);
  }
}
